import apiCallTemplate from "./config";
import credentials from "../assets/credentials";

const { BASE_URL } = credentials;
const wallet = `${BASE_URL}/wallet`;

//initialize payment
export const getUserWallet = async (userId) =>
  apiCallTemplate("get", `${wallet}/${userId}`);

//make transfer
export const updateUserWallet = async (Details) =>
  apiCallTemplate("put", `${wallet}/update-wallet`, Details);

export const getAdminFlutterwaveWalletBalance = async () =>
  apiCallTemplate("get", `${wallet}/get/flutterwave-balance`);
